export default __webpack_public_path__ + "static/media/world-grid.613e6d3d.svg";